var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AccountsComboBox } from './AccountsComboBox';
export class QuickTableAccountsComboBox extends AccountsComboBox {
    getType() {
        return 'QuickTableAccountsComboBox';
    }
    constructor(data, callback, rect) {
        super();
        this.tag = data;
        this.callback = callback;
        this.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
    }
    populateAsync() {
        const _super = Object.create(null, {
            populateAsync: { get: () => super.populateAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.set({ isPosAbsolute: true });
            yield _super.populateAsync.call(this);
            yield this.set({ selectedItem: this.tag.cell.QuickTableEditingInfo.GetDataHandler() });
            this.isShowDropdownMenu = true;
        });
    }
    onDropdownMenuVisibleChanged(isVisible) {
        super.onDropdownMenuVisibleChanged(isVisible);
        if (!isVisible) {
            const selectedItem = this.get('selectedItem');
            this.callback(selectedItem, this.tag);
        }
    }
}
AccountsComboBox.extendWith(QuickTableAccountsComboBox, {});
